import {toTitleCase} from "@/helpers/TextUtils";
import {parseISO} from "date-fns";

export default {
  state: {
    profileDefinitionsData: undefined,
    profileDefinitionsFailed: false,
    selectedProfile: undefined,
    profileSizesByWeek: undefined
  },
  getters: {
    profileDefinitionsLoading(state) {
      return !state.profileDefinitionsData && !state.profileDefinitionsFailed
    },
    nonDeletedProfiles(state) {
      if (!state.profileDefinitionsData) return []
      return state.profileDefinitionsData
          .filter(d => d.metadata.flags && !d.metadata.flags.deleted)
          .map(d => { return {
            id: d.metadata.name,
            name: d.metadata.annotations && d.metadata.annotations['insights/display-name'] ?
              d.metadata.annotations['insights/display-name'] : toTitleCase(d.metadata.name),
            version: d.metadata.profile_version,
            released: d.metadata.flags.released,
            expires: d.metadata.expires,
            annotations: d.metadata.annotations,
          }})
    },
    nonDeletedOrExpiredProfiles(state, data) {
      const now = new Date();
      return data.nonDeletedProfiles
        .filter(d => parseISO(d.expires) > now);
    },
    existingProfileIds(state) {
      return state.profileDefinitionsData
          .map(d => d.metadata.name)
    },
  },
  mutations: {
    clearProfileDefinitions (state) {
      state.profileDefinitionsData = undefined;
    },
    setProfileDefinitions (state, data) {
      state.profileDefinitionsData = Object.freeze(data);
    },
    setSelectedProfile (state, data) {
      state.selectedProfile = Object.freeze(data);
    },
    setProfileDefinitionsFailed (state, failed) {
      state.profileDefinitionsFailed = failed;
    },
    clearProfileProjections (state) {
      state.profileSizesByWeek = undefined;
    },
    setProfileSizesByWeek (state, data) {
      state.profileSizesByWeek = Object.freeze(data);
    },
  },
  actions: {
    async getProfileDefinitionsData(context) {
      if (!context.rootState.login.is_client_admin) return;
      if (context.state.profileDefinitionsData !== undefined) return;

      context.commit('setProfileDefinitionsFailed', false);
      await context.rootState.inst.get(
        `/api/profiles/`,
        {backgroundRequest: true}
      ).then((response) => {
        context.commit('setProfileDefinitions', response.data);
      }).catch(() => {
        context.commit('setProfileDefinitionsFailed', true);
        context.commit('setProfileDefinitions', null);
      });
    },
    async postProfile (context, {data}) {
      await context.rootState.inst.post(
        '/api/profiles/',
        data,
      ).then(() => {
        context.commit('clearProfileDefinitions');
        context.dispatch('getProfileDefinitionsData');
      });
    },
    async deleteProfile (context, {id}) {
      await context.rootState.inst.delete(
        `/api/profiles/${id}/`,
      ).then(() => {
        context.commit('clearProfileDefinitions');
        context.dispatch('getProfileDefinitionsData');
      });
    },
    async releaseProfile (context, {id, version}) {
      await context.rootState.inst.post(
        `/api/profiles/${id}/${version}/release/`,
      ).then(() => {
        context.commit('clearProfileDefinitions');
        context.dispatch('getProfileDefinitionsData');
      });
    },
    async setSelectedProfile(context, {id}) {
      const matching = context.state.profileDefinitionsData.find(p => p.metadata.name === id);
      context.commit('setSelectedProfile', matching);
    },
    async getProfileProjections(context) {
      context.commit('clearProfileProjections');
      await context.rootState.inst.get(
        "/api/profiles/data/",
        {backgroundRequest: true}
      ).then((response) => {
        context.commit('setProfileSizesByWeek', response.data);
      });
    },
  }
}